import React, { Component } from 'react';
import './../../assets/css/App.css';
import CustomChart from './../../component/chart'
import Service from './service';

class ChartView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        renderChart : false
    }

    componentDidMount () {
        Service.event.onFetchSignUpsStatsBySource.add((data) => {
            this.setState({
                histogramChartCategoriesList: data.histogramChartData.categoryList,
                histogramChartSeriesDataList: data.histogramChartData.seriesDataList,
                renderChart : true
            });
        });

        Service.fetchSignUpStatsBySource(30);
    }

    componentWillUnmount() {

    }

    render() {

        const options = {
            title: {
                text: 'Histogram Sign Ups by Source for the last 30 days'
            },
            xAxis: {
                categories: this.state.histogramChartCategoriesList
            },
            yAxis: {
                title: {
                    text: 'Number of Sign ups by source'
                }
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}',
                    }
                }
            },
            series: [{
                name: 'Sign Ups by Source over last 30 days',
                type: 'column',
                colorByPoint: true,
                data: this.state.histogramChartSeriesDataList
            }]
        };

        return (
            <div>
                { this.state.renderChart ? <CustomChart options={options}/> : '' }
            </div>
        );
    }
}

export default ChartView;